import React from 'react';

import { Box, Text } from '@r-client/shared/ui/core';

import {
  AddToCalendarCard,
  IAddToCalendarCardProps,
} from './add-to-calendar-card';

export interface ISuccessViewProps {
  message: string;
  event: IAddToCalendarCardProps['event'];
}

export const SuccessView: React.FC<
  React.PropsWithChildren<ISuccessViewProps>
> = ({ message, event }) => {
  return (
    <Box>
      <Text m="0 0 1.5brm 0" type="h4" align="center">
        {message}
      </Text>
      <AddToCalendarCard event={event} />
    </Box>
  );
};
